import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { updateBooking } from '@/utils/apiEndpoints'; // Check your import path

export const EditGuestModal = ({ open, onClose, guestData, onRefresh }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open && guestData) {
            form.setFieldsValue({
                name: guestData.name,
                email: guestData.email,
                relationship: guestData.relationship
            });
        }
    }, [open, guestData, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            // 1. Get the original list of guests from the row data
            const originalList = guestData.parentGuests || [];
            
            // 2. Create a NEW array with the updated guest
            const updatedGuests = originalList.map(g => {
                // Create a shallow copy so we can delete props without breaking the UI
                const cleanGuest = { ...g }; 

                // Match by ID (preferred) or Name
                const isMatch = (g.id && g.id === guestData.id) || (g.name === guestData.name);
                
                // If this is the guest we are editing, update their values
                if (isMatch) {
                    cleanGuest.name = values.name;
                    cleanGuest.email = values.email;
                    cleanGuest.relationship = values.relationship;
                }

                // --- CRITICAL FIX: Remove Circular Reference & Frontend Props ---
                delete cleanGuest.parentGuests; // <--- Removes the circular link
                delete cleanGuest.isGuest;
                delete cleanGuest.attendeeName;
                delete cleanGuest.bookingId;
                // -------------------------------------------------------------

                return cleanGuest;
            });

            // 3. Send the FULL array to backend
            // NOTE: This assumes your backend 'updateBooking' replaces the 'guests' field.
            await updateBooking(guestData.bookingId, {
                guests: updatedGuests
            });

            message.success("Guest details updated");
            onRefresh(); // Refresh table data
            onClose();
        } catch (error) {
            console.error("Update failed:", error);
            message.error("Failed to update guest details");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={open}
            title="Edit Guest Details"
            onOk={handleOk}
            onCancel={onClose}
            confirmLoading={loading}
            okText="Save"
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item 
                    name="name" 
                    label="Full Name" 
                    rules={[{ required: true, message: 'Name is required' }]}
                >
                    <Input placeholder="Guest Name" />
                </Form.Item>
                <Form.Item 
                    name="email" 
                    label="Email Address"
                    rules={[{ type: 'email', message: 'Please enter a valid email' }]}
                >
                    <Input placeholder="Guest Email (Optional)" />
                </Form.Item>
                <Form.Item name="relationship" label="Relationship">
                    <Input placeholder="e.g. Partner, Friend, Child" />
                </Form.Item>
            </Form>
        </Modal>
    );
};